import { Grid, styled } from "@mui/material";
import {
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
} from "@mui/lab";
import { Skeleton } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

import { getBrandCustom } from "../../../util/getCustomColor";
import { Button, Select } from "../../Form";

export const ActivityMainDiv = styled("div")(() => ({
  "& .MuiTimelineDot-root": {
    marginTop: "0px",
    marginBottom: "0px",
  },
}));

export const ActivityContent = styled(TimelineContent)(() => ({
  padding: "0 10px",
}));

export const ActivityItem = styled(TimelineItem)(() => ({
  marginTop: 0,
}));

export const ActivityConnector = styled(TimelineConnector)(
  ({ disabled }: { disabled?: boolean }) => ({
    backgroundColor: disabled
      ? colors.gray300
      : getBrandCustom("primaryColor", colors.brandBlue500),
    width: "1px",
  })
);

export const ActivityOppositeContent = styled(TimelineOppositeContent)(() => ({
  display: "none",
}));

export const ActivityDot = styled(TimelineDot)(({ disabled }: { disabled?: boolean }) => ({
  backgroundColor: "transparent",
  border: `2px solid ${
    disabled ? colors.gray300 : getBrandCustom("primaryColor", colors.brandBlue500)
  }`,
  borderRadius: "50%",
  "-moz-border-radius": "50%",
  "-webkit-border-radius": "50%",
  width: "20px",
  height: "20px",
  boxShadow: "none",
}));

export const ActivityDotCenter = styled("div")(({ disabled }: { disabled?: boolean }) => ({
  width: "8px",
  height: "8px",
  backgroundColor: disabled ? colors.gray300 : getBrandCustom("primaryColor", colors.brandBlue500),
  borderRadius: "50%",
}));

export const ActivityInfo = styled(Grid)(() => ({
  gap: "4px 24px",
  padding: "8px 0",
}));

export const ActivityLoading = styled(Grid)(() => ({
  gap: "8px",
}));

export const ActivityInfoContent = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
}));

export const ActivityTitle = styled("span")(() => ({
  font: "700 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.1",
  color: colors.gray600,
}));

export const ActivitySubTitle = styled("span")(() => ({
  font: "400 12px Manrope",
  lineHeight: "16px",
  letterSpacing: "0.4px",
  color: colors.gray600,
}));

export const LoadMoreButton = styled(Button)(() => ({
  color: colors.brandBlue500,
  border: "none",
  "&:hover": {
    color: colors.brandBlue500,
  },
  "&:active": {
    border: "none",
  },
}));

export const ActivitySkeletonItem = styled(Skeleton)(() => ({
  transform: "none",
}));

export const ActivityTimelineContainer = styled("div")(({ isModal }: { isModal?: boolean }) => ({
  display: "flex",
  width: "100%",
  height: isModal ? "calc(100vh - 375px)" : "calc(100vh - 285px)",
}));

export const ActivityFiltersContainer = styled("div")(() => ({
  display: "flex",
  padding: "0px 8px 16px 8px",
  gap: "12px",
  alignItems: "flex-start",
  "& .MuiFormControl-root": {
    width: "fit-content",
  },
}));

export const ActivityFilter = styled(Select)(() => ({
  borderRadius: "100px",
  color: colors.gray600,
  font: "600 12px Manrope",
  lineHeight: "16px",
  letterSpacing: "0.5px",
  height: "fit-content",
  "& .MuiSelect-root": {
    padding: "8px 32px 8px 12px",
  },
}));
